import { useMemo } from "react";

import type * as Type from "../type";

type Props = {
	serverData: Type.ServerData.ReservationListByUpdatedDateServerData | undefined;
};
type Result = {
	queryData: Type.QueryData.ReservationListQueryData | undefined;
};

export const useReservationListByUpdatedDateQueryData = ({ serverData }: Props) => {
	return useMemo(
		(): Result => ({
			queryData: serverData
				? {
						hotelName: serverData.reservationListByUpdatedDate.hotelName,
						hotelPrefecture: serverData.reservationListByUpdatedDate.hotelPrefecture,
						reservationList: serverData.reservationListByUpdatedDate.reservations,
					}
				: undefined,
		}),
		[serverData],
	);
};
